import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import StyledContainer from './styled/index'
import Radio from '../input/input-radio'

const RadioGroup = (props) => {
  const {
    options,
    className,
    style,
    onChange,
    name,
    readonly,
    size = 'md',
    checkedValues,
    direction = 'col',
  } = props

  if (!(options && options.length)) {
    return null
  }

  return (
    <StyledContainer
      className={clsx(
        {
          'flex flex-row': direction === 'row',
          'flex flex-col': direction !== 'row',
        },
        className
      )}
      style={style}
    >
      {options.map((item, index) => {
        return (
          <Radio
            key={`radio-${index}-${item.value}`}
            name={name}
            value={item.value}
            onChange={onChange}
            size={size}
            readonly={readonly}
            label={item.label}
            checked={checkedValues.includes(item.value)}
            defaultChecked={item.defaultChecked}
            disabled={item.disabled}
          />
        )
      })}
    </StyledContainer>
  )
}

RadioGroup.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  name: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      name: PropTypes.string,
      value: PropTypes.string,
      defaultChecked: PropTypes.bool,
      disabled: PropTypes.bool,
    })
  ),
  checkedValues: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  direction: PropTypes.oneOf(['row', 'col']),
}
RadioGroup.defaultProps = {
  className: undefined,
  style: undefined,
  name: undefined,
  readonly: false,
  onChange: () => {},
  size: 'md',
  options: [],
  checkedValues: [],
  direction: 'col',
}

export default RadioGroup
